<div class="modal-body _pop-overlay _math-key-popup" id="choose-file-option">
  <div class="mid-panel">
    <div class="_pop-mid-content _math-key-popup _all-file-download _math-file-start" appModalFocusOnInit="100" tabindex="-1">
      <!--start-->
      <div class="_math-key-mid" *ngIf="!isFileUpload">
        <div class="_content start-new">
          <p class="big-font">{{ 'chooseFileModalHeading' | translate }}</p>
          <div>{{ 'chooseFileModalSubHeading1' | translate }}</div>
          <div class="first_box">
            <div class="new-file-grid new_file_grid_2">
              <div
                (click)="createNewBlankFile()"
                (keydown.enter)="createNewBlankFile()"
                class="cursor-pointer box_style"
                autofocus
                appDynamicTabIndex
                tabindex="0"
              >
                <div class="img">
                  <img src="assets/images/blank-icon.svg" [attr.alt]="'blankFileAlt' | translate" />
                </div>
                <p class="pdding-none">{{ 'startNewBlankFile' | translate }}</p>
              </div>
            </div>
            <div class="new-file-grid new_file_grid_2">
              <div class="file-input box_style" (click)="isFileUpload = true" (keydown.enter)="isFileUpload = true" appDynamicTabIndex tabindex="0">
                <label class="file-input__label">
                  <div class="img">
                    <img src="assets/images/file-icon.svg" [attr.alt]="'importPDFOrImageFile' | translate" style="margin: 0px" />
                  </div>
                  <p style="padding: 0px">
                    {{ 'startNewImportFile' | translate }}
                  </p>
                </label>
              </div>
            </div>
          </div>
          <div>{{ 'chooseFileModalSubHeading2' | translate }}</div>
          <div class="second_box">
            <div class="new-file-grid new_file_grid_2" style="border: none" [ngClass]="{ disabled: lastOpenedFileDetails === null }">
              <div
                class="box_style"
                [ngClass]="{ 'cursor-pointer': lastOpenedFileDetails != null }"
                autofocus
                appDynamicTabIndex
                tabindex="0"
                (click)="openMostRescentFile()"
                (keydown.enter)="openMostRescentFile()"
              >
                <div class="img">
                  <img src="assets/images/blank-icon-choose.svg" [attr.alt]="'blankFileAlt' | translate" />
                </div>
                <p class="pdding-none">{{ 'chooseFileModalMostRescent' | translate }}</p>
              </div>
            </div>
            <div class="new-file-grid new_file_grid_2" style="border: none" [ngClass]="{ disabled: isFileCreated }">
              <div
                class="box_style"
                [ngClass]="{ 'cursor-pointer': !isFileCreated }"
                autofocus
                appDynamicTabIndex
                tabindex="0"
                (click)="!isFileCreated && openFileManager()"
                (keydown.enter)="!isFileCreated && openFileManager()"
              >
                <div class="img">
                  <img src="assets/images/file-blue2.svg" [attr.alt]="'blankFileAlt' | translate" />
                </div>
                <p class="pdding-none">{{ 'chooseFileModalOpenFileManager' | translate }}</p>
              </div>
            </div>
          </div>
          <div style="font-size: 16px; padding: 0px 10px" class="d-flex justify-content-between w-100">
            <div>
              {{ 'chooseFileModalOtherOptions' | translate }}
              <img class="_custom_tooltip2" src="assets/images/Info.svg" title="{{ 'chooseFileModalOtherOptionsTooltip' | translate }}" />
            </div>
            <div style="cursor: pointer" (click)="logout()" appDynamicTabIndex tabindex="0" (keydown.enter)="logout()">
              {{ 'chooseFileModalLogOff' | translate }}
            </div>
          </div>

          <!-- <div class="new-file-grid">
            <div class="file-input"  (click)="loadGoogleDrive()">
              <label class="file-input__label">
                <div class="img">
                  <img src="assets/images/google-new-drive-file.svg" alt="popup" class="" />
                </div>
                <p>Import a file from Google Drive</p>
              </label>
            </div>
          </div> -->
        </div>
      </div>
      <!--end-->
      <div class="_math-key-mid _form-popup _file-panel" *ngIf="isFileUpload">
        <p class="big-font">
          {{ 'startNewChooseMathAssignment' | translate }}
        </p>
        <form class="_form-section">
          <!--form feild start-->
          <div class="form-field _input-file">
            <div class="file-input">
              <input
                type="file"
                id="file-input-new"
                class="file-input__input"
                (change)="handleFileInput($event.target)"
                accept=".png, .jpeg, .jpg, .kiwi, .pdf"
                tabindex="-1"
              />
              <label class="file-input__label" for="file-input-new" appDynamicTabIndex tabindex="0" (keydown.enter)="triggerFileInput()">
                <div class="img">
                  <img
                    [src]="
                      isPdf
                        ? 'assets/images/pdf-icon.svg'
                        : binaryUrl
                          ? binaryUrl
                          : kiwiFileData
                            ? 'assets/images/logo.png'
                            : 'assets/images/file-blue.svg'
                    "
                    [alt]="isPdf ? ('pdfFileAlt' | translate) : ('doneFolderForCompleteWorkAlt' | translate)"
                  />
                </div>
                <span>
                  {{ 'startNewFileDrag' | translate }}
                </span>
              </label>
            </div>
            <progressbar [animate]="false" [value]="startUploading" type="success" *ngIf="startUploading"
              ><strong>{{ startUploading }}%</strong></progressbar
            >
            <!--end-->
            <label class="error">
              {{ fileTypeError }}
            </label>
          </div>
        </form>
        <div class="_popup-btn">
          <button (click)="goToImportPage()" class="button" appDynamicTabIndex tabindex="0">
            <div class="d-flex align-items-center">
              <span class="mr-3">{{ 'cancel' | translate }}</span>
              <img class="ml-auto next-arrow mb-n1" src="assets/images/next-arrow.svg" aria-hidden="true" width="13" height="15" />
            </div>
          </button>
          <button (click)="toRenderFile()" class="button secondary" autofocus appDynamicTabIndex tabindex="0">
            <div class="d-flex align-items-center">
              <span class="mr-3">{{ 'okay' | translate }}</span>
              <img class="ml-auto next-arrow mb-n1" src="assets/images/next-arrow.svg" aria-hidden="true" width="13" height="15" />
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
